// cart-progress.js - Noviembre
(function(){
  const sel = {
    box: '.nh-free-ship',
    msg: '#nhMsg',
    bar: '#nhBar'
  };

  function el(q){ return document.querySelector(q); }
  function money(cents, fmt){
    // Usa el formateador de Shopify si existe
    try { return Shopify.formatMoney(cents, fmt || '${amount}'); }
    catch(e){ return '$' + (cents/100).toFixed(2); }
  }

  async function getCart(){
    const r = await fetch('/cart.js', { credentials:'same-origin' });
    return r.ok ? r.json() : null;
  }

  async function update(){
    const box = el(sel.box); if(!box) return;
    const fmt = box.getAttribute('data-money-format') || '${amount}';
    const thr = parseInt(box.getAttribute('data-threshold-cents')) || 4500; // $45
    const cart = await getCart(); if(!cart) return;
    const subtotal = cart.items_subtotal_price; // en centavos
    const left = Math.max(thr - subtotal, 0);
    const pct = Math.min(100, Math.round(subtotal / thr * 100));

    const msg = el(sel.msg);
    const bar = el(sel.bar);

    if (msg) {
      if (left > 0) {
        msg.innerHTML = `Add <strong>${money(left, fmt)}</strong> more for <strong>FREE</strong> shipping`;
      } else {
        msg.innerHTML = `Free standard shipping unlocked!`;
      }
    }

    if (bar) bar.style.width = pct + '%';
  }

  document.addEventListener('cart:updated', update);
  update();
})();